import propertyOrNull from '@99designs/utils/app/propertyOrNull';

export default { fromJSON };

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    const data = {
        messageHtml: propertyOrNull(json, 'messageHtml'),
        isRead: propertyOrNull(json, 'isRead'),
        icon: propertyOrNull(json, 'icon'),
        thumbnailUrl: propertyOrNull(json, 'thumbnailUrl'),
        destinationUrl: propertyOrNull(json, 'destinationUrl'),
        lastActivityAt: propertyOrNull(json, 'lastActivityAt'),
        links: {
            self: propertyOrNull(json._links.self, 'href'),
        },
    };

    return data;
}



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/src/models/onsite-notification.js